import type { Messages } from '@lingui/core'
import { messages as enProdMessages } from '@/../../translations/locales/en/messages.po'

export function getMessagesFromCatalogModule(module: {
  default?: unknown
  messages?: unknown
}): Messages {
  if (module.messages) {
    return module.messages as Messages
  }

  if (
    module.default &&
    typeof module.default === 'object' &&
    'messages' in module.default &&
    module.default.messages
  ) {
    return module.default.messages as Messages
  }

  return (module.default as Messages) ?? {}
}

export async function loadTranslation(locale: string) {
  const data = await import(
    `@/../../translations/locales/${locale}/messages.po`
  )

  return getMessagesFromCatalogModule(data)
}

/** Sync load of default (en) messages for SSR/build when pageProps.translation is missing */
export function getDefaultMessagesSync(): Messages {
  if (typeof window !== 'undefined') return {}

  return getMessagesFromCatalogModule({ messages: enProdMessages })
}
